import $ from "jquery";
$(".menu-toggler").click(function () {
    $(this).toggleClass("active");
    $(".header__nav-wrapper").toggleClass("opened");
    $('.overlay').toggleClass('active');
});
$('.header__nav a[href="#"]').click(function (e) {
    e.preventDefault();
});
$(".header__nav-wrapper .menu-item-has-children").append('<button class="toggle-sub-menu" aria-label="Ouvrir/Fermer le menu"></button>');
$(".header__nav-wrapper .toggle-sub-menu").click(function (e) {
    $(this).parent().toggleClass("menu-item--opened");
});